/**
 * Block type → family for the data-<ns>-group attribute, for this package's blocks, as
 * `BLOCK_GROUPS` in `@akademi/site-builder-blocks` is for its own. A host looks a block up in both.
 */
export const COMMERCE_BLOCK_GROUPS: Record<string, string> = {
  AccountDashboard: 'commerce',
  AccountOrderDetail: 'commerce',
  ActivateAccountForm: 'auth',
  AddToCartButton: 'commerce',
  AddressBook: 'commerce',
  BrandStrip: 'commerce',
  CartView: 'commerce',
  SavedListsView: 'commerce',
  CheckoutForm: 'commerce',
  ConfirmEmailChange: 'auth',
  FacetPanel: 'commerce',
  ForgotPasswordForm: 'auth',
  DepartmentStoreHome: 'commerce',
  ElectricalTradeHome: 'commerce',
  EthicalMarketplaceHome: 'commerce',
  EverydayFitHome: 'commerce',
  HeritageSportHome: 'commerce',
  JobsiteSupplyHome: 'commerce',
  KitEnquiryCta: 'commerce',
  MinimalEssentialsHome: 'commerce',
  OrderConfirmation: 'commerce',
  OrderTracking: 'commerce',
  ProductDetail: 'commerce',
  ProductGrid: 'commerce',
  RegisterForm: 'auth',
  ResetPasswordForm: 'auth',
  RoomDesignHome: 'commerce',
  SignInForm: 'auth',
  StoreLocator: 'commerce',
  TradeCounterHome: 'commerce',
  TradeApplicationForm: 'commerce',
  InstallerApplicationForm: 'commerce',
  InstallerDocuments: 'commerce',
};
